import React from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux';

import './../../styles/app.css';
import levelSelectedAction from "../../actions/levelSelectedAction";
import onLevelButtonOverAction from "../../actions/onLevelButtonOverAction";
import onLevelButtonOutAction from "../../actions/onLevelButtonOutAction";

const _ApartmentLandingPage = (props) => {
    // because of the labeling, we need to do some sorting to get the level array in the right order
    let sorted = Object.keys(props.blob.levels).sort();
    let end = sorted.pop();
    sorted.unshift(end);

    return (
        <div>
            <div className="ispi-render-container">
                <img src={props.blob.render} style={{width: '100%'}} />
                <svg viewBox="0 500 2000 2000" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="100%">
                    {sorted.map(lvl =>
                        <polygon
                            key={lvl}
                            className={props.levelHover !== null && props.levelHover === lvl ? "polygon-hoverable-gold hovered" : "polygon-hoverable-gold" }
                            points={props.blob.levels[lvl].coords}
                            onClick={props.onLevelSelect(lvl)}
                            onMouseOver={props.onLevelButtonOver(lvl) /* TRICK: with both a hovered class and a on-hover css style, we can apply the same dispatch event to both elements for two-way hover highlighting */}
                            onMouseOut={props.onLevelButtonOut()} />
                    )}
                </svg>
            </div>
            <div className="ispi-level-select-container">
                <img className="ispi-brand-logo" src={props.blob.logo} alt="" />
                <div className="ispi-level-select">
                    <ul>
                        {sorted.map(lvl =>
                            <li
                                className={props.levelHover !== null && props.levelHover === lvl ? "font-mm colour-bg-lg gr-btn-hover hovered" : "font-mm colour-bg-lg gr-btn-hover"}
                                key={lvl}
                                data-key={lvl}
                                onClick={props.onLevelSelect(lvl)}
                                onMouseOver={props.onLevelButtonOver(lvl) /* TRICK: with both a hovered class and a on-hover css style, we can apply the same dispatch event to both elements for two-way hover highlighting */}
                                onMouseOut={props.onLevelButtonOut()}>LEVEL {lvl}</li>
                        )}
                    </ul>
                    <div className="ispi-down-chevron-container ispi-visible-desktop">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 220 80">
                            <polyline points="0 0 110 70 220 0" stroke="#58595b" fill="transparent" strokeWidth="20px" />
                        </svg>
                    </div>
                    <a className="download-pdf-btn landing-page" href={props.blob.pdf} target="_blank">DOWNLOAD BROCHURE</a>
                    <div className="disclaimer">
                        These plans are intended as a guide only. The dimensions and areas are approximate only and may not accurately represent the actual dimensions and areas of the apartments or the spaces within them and are subject to change without notice. In addition, locations of utilities may vary during construction and fittings and fixtures on these plans are for illustrative purposes only. The areas are generally measured in accordance with the Property Council of Australia method of measurement. Prospective purchasers must rely on their own enquiries and should refer to the Contract of Sale and its schedules for all matters to be included in the purchase price of the apartment, including plans, finishes, fixtures, fittings, appliances and other particulars of sale. Loose furniture and planters are not included. Extent of floor finishes may vary. External space and landscaping indicative only. Refer to level plans for further information.
                    </div>
                </div>
            </div>
        </div>
    );
};

// map the blob object in the state to the props param
const mapStateToProps = state => {
    return {
        blob: state.data.blob,
        levelHover: state.data.levelHover
    };
};

// define the following functions as available from the props param
const mapDispatchToProps = dispatch => {
    return {
        onLevelSelect: (selectedLevel) => {
            // return an onClick usable function that changes routes
            return () => {
                // dispatch a hover out action to clear any hovers so they don't persist across page changes
                dispatch(onLevelButtonOutAction(null));
                dispatch(push(`/apartments/level/${selectedLevel}`));
            };
        },
        onLevelButtonOver: (selectedLevel) => {
            return () => {
                // store the hovered level
                dispatch(onLevelButtonOverAction(selectedLevel));
            }
        },
        onLevelButtonOut: () => {
            return () => {
                // dispatch null to clear any hover states
                dispatch(onLevelButtonOutAction(null));
            }
        }
    };
};

// this function performs all the hookups that allow the above mapping to happen
const ApartmentLandingPage = connect(
    mapStateToProps,
    mapDispatchToProps
)(_ApartmentLandingPage);

export default ApartmentLandingPage;


// WEBPACK FOOTER //
// ./src/pages/landing-page/ApartmentLandingPage.js